import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './Hamburger.module.less';

export default function Hamburger({
  open = false,
  onClick,
  mobileOnly = false,
  desktopOnly = false,
}) {
  const handleClick = event => {
    if (event.type === 'click' || event.key === ' ' || event.key === 'Enter') {
      onClick(event);
    }
  };

  return (
    <div
      className={clsx(
        styles.hamburger,
        styles.hamburgerSlider,
        open && styles.open,
        mobileOnly && styles.mobileOnly,
        desktopOnly && styles.desktopOnly
      )}
      onClick={handleClick}
      onKeyDown={handleClick}
      role="button"
      title="Main menu"
    >
      <span className={styles.hamburgerBox}>
        <span className={styles.hamburgerInner} />
        <span className={clsx(styles.hamburgerInner, styles.thirdLine)} />
      </span>
    </div>
  );
}

Hamburger.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  mobileOnly: PropTypes.bool,
  desktopOnly: PropTypes.bool,
};
